<!-- eslint-disable max-len -->
<template lang="pug">
.container
  Breadcrumb
  h1.h-medium-lg.fw-500 Seus documentos foram enviados com sucesso!
  .main(role='main')
    .row.justify-content-between
      .col-md-6
        .info-card
          h2.color--primary O que vai acontecer agora?
          p.d-flex
            Icon.icon-check(name='circle-check')
            span Agora um de nossos Agentes fará a #[strong análise dos documentos.]
          p.d-flex
            Icon.icon-check(name='circle-check')
            span Assim que estiver tudo certo, você #[strong receberá as instruções para os próximos passos no seu e-mail.]

        .form-card
          h4.fw-400 Enquanto isso você pode consultar o andamento da sua solicitação.
          .row
            .alert.alert-dismissible.col-lg-12(
              :class='[alert.isShow ? "d-flex " : "d-none"]',
              role='alert'
            )
              .alert__icon
                Icon(:name='getIconAlert')
              .alert__content {{ alert.message }}
              button.btn-close.align-items-center(
                type='button',
                data-bs-dismiss='alert',
                aria-label='Fechar'
              )
                Icon.icon(name='xmark')
          #codigo(
            style='word-break: break-all',
            v-if='form.codigoSolicitacao !== ""'
          )
            #tooltip-cod(
              :title='tooltipMessage',
              @click='copyTextToClipboard',
              @mouseover='createTooltip("#tooltip-cod")'
            )
            span.text-by-copie Código da solicitação:&nbsp;
            span.fw-600.button-copy(:key='count') {{ form.codigoSolicitacao }}
            Icon.col-2.button-copy.ms-2(
              name='copy',
              @click='copyTextToClipboard'
            )

          .justify-content-start
            a#btnCopy.btn.btn-primary.col-md-12.col-lg-6(
              type='button',
              target='_blank',
              :href='`https://${arData.subdomain}.acsoluti.com.br/site/verificar-situacao-de-emissao`'
            )
              span Consultar andamento
              Icon.ms-2(name='magnifying-glass')
      .col-md-6.card-image
        img(src='@/assets/images/hi-five.svg')

  Contact(style='margin-bottom: 6rem')
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import Wizzard from '@/components/Molecules/Wizzard.vue'
  import Input from '@/components/Atoms/Input.vue'
  import { mapState } from 'pinia'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useAR } from '@/store/Pinia/useAR.store'
  import { Tooltip } from 'bootstrap'

  export default defineComponent({
    name: 'SuccessUploadFilesView',
    components: {
      Icon,
      Contact,
      Input,
      Breadcrumb,
      Wizzard,
    },
    data: () => ({
      model: {
        codigoSolicitacao: '',
        documento: '',
      },
      form: {
        codigoSolicitacao: '',
      },
      tooltipMessage: 'Clique para copiar',
      alert: {
        isShow: false,
        message: '',
        type: 'info',
      },
      count: 1,
    }),
    computed: {
      ...mapState(useSolicitation, ['getSolicitation']),
      ...mapState(useAR, ['arData']),
      getIconAlert() {
        if (this.alert.type === 'danger') return 'circle-xmark'
        if (this.alert.type === 'warning') return 'circle-info'
        if (this.alert.type === 'info') return 'bell'

        return 'circle-check'
      },
    },
    mounted() {
      this.form.codigoSolicitacao = this.getSolicitation.cdSolicitacao
    },
    methods: {
      async copyTextToClipboard() {
        await navigator?.clipboard
          ?.writeText(this.form.codigoSolicitacao)
          ?.catch((err) => {
            console.error('Could not copy text: ', err)
          })

        const textTooltip = document.getElementsByClassName('tooltip-inner')

        if (textTooltip.length > 0) {
          textTooltip[0].innerHTML = 'Código copiado'
        }
        setTimeout(() => {
          textTooltip[0].innerHTML = 'Clique para copiar'
        }, 3000)
      },
      createTooltip(id: string) {
        const tooltip = new Tooltip(id)
        tooltip.show()
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .container
    padding: 1rem

  .info-card
    margin-top: 2.5rem;
    background-color: var(--color-grayscale-light)
    padding: 2rem
    border-radius: 1rem
    h2
      font-size: 1.5rem
  .main
    text-align: left !important;
    display: flex;
    flex-direction: column
    gap: 3em;
  .button-copy
    cursor: pointer;
  .h-medium-lg
    font-size: 2rem;
    text-align: left;
    line-height: 3rem
  .icon-check
    color: var(--color-success-600)
    margin-right: 0.5rem

  img
    width: 80%;
    margin-top: 2.5rem;

  .form-card
    margin-top: 1rem;
    display: flex
    flex-direction: column
    padding: 2rem
    gap: 0.5rem;
    border-radius: 1rem;
    border: 1px solid var(--color-grayscale-default)

  #tooltip-cod
    width: 26rem;
    height: 20px;
    position: absolute;
    opacity: 0;
    z-index: 999999;
    cursor pointer

   @media screen and (max-width: 700px)
    .text-by-copie
      display: block;

    .card-image
      display: none

  @media screen and (max-width: 990px)
    .column-image
      display: none
    .form-card
      flex-direction: column
</style>
